import React, { useState, useContext } from "react";
import "./StartupProjects.scss";
import { bigProjects } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

const GetDescBullets = ({ descBullets, isDark, expandedProject, projectIndex }) => {
  return descBullets ? (
    <ul className={`project-bullets ${expandedProject === projectIndex ? 'show' : ''}`}>
      {descBullets.map((item, i) => (
        <li key={i} className={isDark ? "subTitle dark-mode-text" : "subTitle"}>
          {item}
        </li>
      ))}
    </ul>
  ) : null;
};

export default function StartupProject() {
  const { isDark } = useContext(StyleContext);
  const [expandedProject, setExpandedProject] = useState(null);

  function toggleProject(index) {
    setExpandedProject(expandedProject === index ? null : index);
  }

  function openUrlInNewTab(url) {
    if (!url) return;
    const win = window.open(url, "_blank");
    win.focus();
  }

  if (!bigProjects.display) return null;

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>
          <h1 className="skills-heading">{bigProjects.title}</h1>
          <p className={isDark ? "dark-mode project-subtitle" : "subTitle project-subtitle"}>
            {bigProjects.subtitle}
          </p>

          <div className="projects-container">
            {bigProjects.projects.map((project, i) => (
              <div
                key={i}
                className={isDark ? "dark-mode project-card project-card-dark" : "project-card project-card-light"}
                onClick={() => toggleProject(i)}
              >
                <div className="project-detail">
                  <h5 className={isDark ? "dark-mode card-title" : "card-title"}>
                    {project.gitlink ? (
                      <a 
                        href={project.gitlink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="project-title-link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {project.projectName}
                      </a>
                    ) : (
                      project.projectName
                    )}
                  </h5>
                  <GetDescBullets descBullets={project.descBullets} isDark={isDark} />
                  {project.footerLink && (
                    <div className="project-card-footer">
                      {project.footerLink.map((link, i) => (
                        <span
                          key={i}
                          className={isDark ? "dark-mode project-tag" : "project-tag"}
                          onClick={(e) => {
                            e.stopPropagation();
                            openUrlInNewTab(link.url);
                          }}
                        >
                          {link.name}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                {project.images && (
                  <div className="project-images-container">
                    {project.images.map((image, index) => (
                      <div key={index} className="project-image">
                        <img src={image} alt={`${project.projectName} - ${index + 1}`} className="card-image" />
                      </div>
                    ))}
                  </div>
                )}
                <p className={isDark ? "dark-mode card-subtitle" : "card-subtitle"}>{project.projectDesc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Fade>
  );
}
